import { Instagram, PawPrint } from "lucide-react";
import { Avatar, Tape, Topo } from "@/components/Brand";
import { BriefingSection } from "@/components/LandingBriefing";

const COMMUNITY_TEAM = [
  { name: "Andi Sabrina", handle: "shabolly", role: "Founder" },
  { name: "Imanuel Juan", handle: "imanueljuanjunior", role: "Partnership and Relation" },
  { name: "Muhammad Aditya", handle: "pulun_x", role: "Technical Team" },
  { name: "Fadhil Muflih", handle: "fadhilmuflih_", role: "Technical Team" },
  { name: "Imanuel Rodito", handle: "immanuelrodito", role: "Technical Team" },
  { name: "Farhan Nabil", handle: "farhan_nabil_", role: "Technical Team" },
  { name: "Dava Rachman", handle: "davarchmn_", role: "Creative Media" },
  { name: "Febri", handle: "f.rjahhh", role: "Queue Coordinator" },
];

function AboutUs() {
  return (
    <section id="tentang" className="relative overflow-hidden border-t border-[#1A3323]/10 bg-[#F7F4EA] py-16 sm:py-24">
      <Topo className="absolute -left-32 top-0 h-72 w-[36rem] text-[#3D6F4B]/10" />
      <div className="relative mx-auto grid max-w-6xl gap-10 px-6 lg:grid-cols-[.8fr_1.2fr] lg:px-14">
        <div>
          <Tape>about us</Tape>
          <h2
            className="mt-4 max-w-md text-4xl font-extrabold leading-tight text-[#1A3323] sm:text-5xl"
            data-testid="about-us-heading"
          >
            Naik bareng, belajar bareng, pulang dengan cerita baru.
          </h2>
        </div>
        <div className="max-w-2xl space-y-5 text-base leading-relaxed text-[#1A3323]/78">
          <p data-testid="about-us-intro">
            Iya Lagi Manjat adalah komunitas climbing yang terbuka untuk semua level pengalaman.
            Kami datang untuk bergerak, belajar, dan menikmati proses di wall bersama-sama.
          </p>
          <p data-testid="about-us-safety">
            Keselamatan dan etika selalu jadi pegangan: saling jaga ruang, dengarkan arahan, dan
            jangan ragu untuk bertanya sebelum mencoba sesuatu yang baru.
          </p>
          <div className="grid gap-3 pt-2 sm:grid-cols-2">
            <div className="flex gap-3 border-l-2 border-[#3D6F4B] pl-3" data-testid="about-us-inclusive">
              <PawPrint className="mt-0.5 h-5 w-5 shrink-0 text-[#3D6F4B]" />
              <span>Ruang yang suportif untuk tumbuh bersama.</span>
            </div>
            <div className="flex gap-3 border-l-2 border-[#7C9A6E] pl-3" data-testid="about-us-safety-value">
              <PawPrint className="mt-0.5 h-5 w-5 shrink-0 text-[#3D6F4B]" />
              <span>Berani belajar, tetap saling menjaga.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function CommunityTeam() {
  return (
    <section className="bg-[#F7F4EA] py-16 sm:py-24" data-testid="community-team-section">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 lg:grid-cols-[.7fr_1.3fr] lg:px-14">
        <div>
          <Tape>orang di balik wall</Tape>
          <h2 className="mt-4 text-4xl font-extrabold leading-tight text-[#1A3323] sm:text-5xl" data-testid="community-team-heading">
            Pengurus Komunitas
          </h2>
          <p className="mt-4 max-w-sm text-base leading-relaxed text-[#1A3323]/70">
            Tim yang menjaga sesi, relasi, dan cerita Iya Lagi Manjat tetap bergerak bersama.
          </p>
        </div>
        <div className="grid gap-x-8 gap-y-0 sm:grid-cols-2">
          {COMMUNITY_TEAM.map(({ name, handle, role }, index) => (
            <div
              key={name}
              className="group border-b border-[#1A3323]/10 py-4"
              data-testid={`community-team-member-${index + 1}`}
            >
              <div className="flex items-center gap-3">
                <Avatar
                  name={name}
                  size={42}
                  testId={`community-team-member-avatar-${index + 1}`}
                />
                <div className="min-w-0">
                  <a
                    href={`https://www.instagram.com/${handle}/`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1.5 text-lg font-extrabold text-[#1A3323]
                      transition-colors hover:text-[#3D6F4B] focus-visible:outline-none
                      focus-visible:ring-2 focus-visible:ring-[#3D6F4B] focus-visible:ring-offset-2"
                    aria-label={`Kunjungi Instagram ${name}, @${handle}`}
                    data-testid={`community-team-member-instagram-${index + 1}`}
                  >
                    <span data-testid={`community-team-member-name-${index + 1}`}>{name}</span>
                    <Instagram className="h-4 w-4 shrink-0" aria-hidden="true" />
                  </a>
                  <div
                    className="mt-1 text-sm font-semibold text-[#3D6F4B]"
                    data-testid={`community-team-member-role-${index + 1}`}
                  >
                    {role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LandingCommunity() {
  return (
    <div>
      <AboutUs />
      <BriefingSection />
      <CommunityTeam />
    </div>
  );
}